
import { ioDatatypes } from "../../brefs.js";
import { lodash as _, lolo as __, jsHelper } from "../../xlib.js";
import { React, ReactDOM, Redux, ReactRedux, ReactRouter, History, ReduxSimpleRouter, ReactBootstrap, ReactLoader as Loader, Cookie } from "../../blib.js";

import * as xlib from "../../../../xlib/index.js";
import * as blib from "../../../../blib/index.js";



import { IndexRoute, Router, Route, Link } from "react-router";

///////////////////  APP FOLLOWING PATTERNS FROM: http://localhost:8080/auth-with-shared-root/   (react-router example)





//import Cookie = blib.Cookie;

//import xlib = refs.xlib;
// var _ = xlib.lodash;
// var __ = xlib.lolo;
var log = new xlib.diagnostics.logging.Logger( __filename );
xlib.diagnostics.logging.logPromiseUnhandledRejections();
//var jsHelper = xlib.jsHelper;

//import blib = refs.blib;


// import React = blib.React;
// import ReactDOM = blib.ReactDOM;
// import Redux = blib.Redux;
// import ReactRedux = blib.ReactRedux;
// import ReactRouter = blib.ReactRouter; //tested with 1.x, not sure if it works with 2.x
// import History = blib.History;
// import ReactBootstrap = blib.ReactBootstrap;
// import ReduxSimpleRouter = blib.ReduxSimpleRouter;

//import * as ReduxSimpleRouter from "redux-simple-router"



//import ioDatatypes = refs.ioDatatypes;

import * as config from "../client-config.js";

import * as commonComponents from "./commoncomponents.js";

import { errorPopupContent } from "./error-popup.js";
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////
export module reduxScafolding {


    /**
     * functional, but DO NOT copy/paste this pattern, it is deprecated in favor of the pattern found in accounddetails.tsx
     */
    module ActionType {
        export const LOGIN_NOTIFY = "authentication.LOGIN_NOTIFY";
        export const LOGOUT = "authentication.LOGOUT";
    }

    /**
     * functional, but DO NOT copy/paste this pattern, it is deprecated in favor of the pattern found in accounddetails.tsx
     */
    export interface IReduxState {
        isLoggedIn: boolean;
    }



    /**
     * functional, but DO NOT copy/paste this pattern, it is deprecated in favor of the pattern found in accounddetails.tsx
     */
    export var action = {
        LoginNotify(): blib.IActionResult<void> {

            return {
                type: ActionType.LOGIN_NOTIFY,
                value: null,
            };
        },

        Logout(): blib.IActionResult<void> {

            blib.Cookie.remove( "isLogedIn" );

            return {
                type: ActionType.LOGOUT,
                value: null,
            };
        }
    }
    /**
     * functional, but DO NOT copy/paste this pattern, it is deprecated in favor of the pattern found in accounddetails.tsx
     */
    export type Action = typeof action;

    /**
     * functional, but DO NOT copy/paste this pattern, it is deprecated in favor of the pattern found in accounddetails.tsx
     */
    const initialState: IReduxState = {
        isLoggedIn: false,
    }

    /**
     * functional, but DO NOT copy/paste this pattern, it is deprecated in favor of the pattern found in accounddetails.tsx
     */
    export function reducer( state = initialState, action: blib.IActionResult<IReduxState> ) {
        var newState = _.clone( state );
        switch ( action.type ) {
            case ActionType.LOGIN_NOTIFY:
                newState.isLoggedIn = true;
                return newState;
            case ActionType.LOGOUT:
                newState.isLoggedIn = false;
                return newState;
            default:
                return state;
        }

    }
}

export module components {

    class _SignupOrEmptyButton extends React.Component<reduxScafolding.IReduxState & reduxScafolding.Action & { pushPath: typeof ReduxSimpleRouter.pushPath }, {}>{
        render() {
            if ( this.props.isLoggedIn === true ) {
                return <span />
            } else {
                return <button className="btn btn-secondary nav-item" onClick={ () => { this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signup ) } }><div className="small"><strong>Sign Up</strong></div></button>
            }
        }
    }

    class I_SignupOrEmptyButton extends React.Component<{}, {}>{ };

    /**
     * a button that says "logout" when logged in, and "Login" when logged out
     */
    export var SignupOrEmptyButton = ReactRedux.connect(
        ( reduxStoreState ) => _.clone( reduxStoreState.authentication ) //subscripbe to reduxStore updates (Called every change). 
        , _.merge( {}, reduxScafolding.action, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //bind actions to props
    )( _SignupOrEmptyButton ) as any as typeof I_SignupOrEmptyButton;

    class _LoginOrLogoutButton extends React.Component<reduxScafolding.IReduxState & reduxScafolding.Action & { pushPath: typeof ReduxSimpleRouter.pushPath }, {}>{
        render() {
            if ( this.props.isLoggedIn === true ) {
                // one root element (React 15): the button and the sign-out error modal
                return (
                    <span>
                        <button className="btn btn-secondary nav-item " onClick={ () => this.signOut() }><div className="small"><strong>Log Out</strong></div></button>
                        <commonComponents.EzModal ref="Modal" />
                    </span>
                );
            } else {
                return <button className="btn btn-secondary nav-item " onClick={ () => { this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.login ) } }><div className="small"><strong>Log In</strong></div></button>
            }
        }

        /**
         * sign-out (session pass): the server clears the HttpOnly `token` and `isLogedIn` in this browser; on success the local logout runs;
         * on failure the error popup shows and the user stays signed in (a marker-only sign-out would leave the token live)
         */
        private signOut() {
            const target = window.location.origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_logout;
            return xlib.net.axios.post( target, {} )
                .then( () => {
                    this.props.Logout();
                } )
                .catch( ( err ) => {
                    const content = errorPopupContent( "Error signing out", "response from server:", err.response == null ? "NONE" : err.response.data );
                    var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
                    if ( modal != null ) { modal.ShowError( content ); }
                } );
        }
    }

    class I_LoginOrLogoutButton extends React.Component<{}, {}>{ };

    /**
     * a button that says "logout" when logged in, and "Login" when logged out
     */
    export var LoginOrLogoutButton = ReactRedux.connect(
        ( reduxStoreState ) => _.clone( reduxStoreState.authentication ) //subscripbe to reduxStore updates (Called every change). 
        , _.merge( {}, reduxScafolding.action, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //bind actions to props
    )( _LoginOrLogoutButton ) as any as typeof I_LoginOrLogoutButton;

    class _LoginStatusMonitor extends React.Component<reduxScafolding.Action & { logedInRedirect?: string, logedOutRedirect?: string } & { pushPath: typeof ReduxSimpleRouter.pushPath }, {}>{

        private static _totalRedirects = 0;

        componentDidMount() {

            log.debug( "componentDidMount", this.props );

            this.detectLogedIn();



        }


        componentDidUpdate() {
            //log.debug("componentDidUpdate",arguments);
            this.detectLogedIn();
        }
        render() {
            if ( __.isTrace === true ) {
                return ( <components.DebugVisualizer /> );
            } else {
                return null;
            }
        }

        private detectLogedIn() {

            //log.debug("location",window.location);

            //log.assert(false, "test");
            if ( _LoginStatusMonitor._totalRedirects > 10 ) {
                log.assert( false, "too many redirects" );
                return;
            }
            var result = blib.Cookie.get( "isLogedIn" );


            var currentRoute = xlib.stringHelper.removeBefore( window.location.hash, "#" ).toLowerCase();
            currentRoute = xlib.stringHelper.removeAfter( currentRoute, "?" );
            if ( result === "true" ) {
                this.props.LoginNotify();

                if ( this.props.logedInRedirect != null && currentRoute !== this.props.logedInRedirect.toLowerCase() ) {
                    _LoginStatusMonitor._totalRedirects++;
                    //log.assert(false, "redirect login");
                    this.props.pushPath( this.props.logedInRedirect );
                    return;
                }
            } else {
                this.props.Logout();

                if ( this.props.logedOutRedirect != null && currentRoute !== this.props.logedOutRedirect.toLowerCase() ) {
                    _LoginStatusMonitor._totalRedirects++;
                    //log.assert(false, "redirect logout");
                    this.props.pushPath( this.props.logedOutRedirect );
                    return;
                }

            }
            // stable route for the cookie state: the redirect cap counts only consecutive redirects (a ping-pong never reaches here),
            // so repeated in-page sign-in/sign-out cycles and session refusals keep redirecting (legacy: page-lifetime count, never reset)
            _LoginStatusMonitor._totalRedirects = 0;

        }
    }

    class ILoginStatusMonitor extends React.Component<{ logedInRedirect?: string, logedOutRedirect?: string }, {}>{ };

    /**
     * add this to your dom to detect if the "isLogedIn" cookie is present, thus determining if the user is loged in
     */
    export var LoginStatusMonitor = ReactRedux.connect(
        ( reduxStoreState ) => _.clone( reduxStoreState.authentication ) //subscripbe to reduxStore updates (Called every change). 
        , _.merge( {}, reduxScafolding.action, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //bind actions to props
    )( _LoginStatusMonitor ) as typeof ILoginStatusMonitor;

    class _DebugVisualizer extends React.Component<reduxScafolding.IReduxState & reduxScafolding.Action, {}>{
        render() {


            if ( __.isTrace === false ) return null;

            return (
                <div className="card">
                    <div className="card-block alert-warning">
                        <code>authentication.DebugVisualizer</code>
                        <ReactBootstrap.Button onClick={ this.props.Logout }>Logout</ReactBootstrap.Button>
                        <ReactBootstrap.Button onClick={ this.testDeleteCookie }>DeleteCookie</ReactBootstrap.Button>
                        <pre>{ JSON.stringify( this.props, undefined, "\t" ) }</pre>
                    </div>
                </div>
            );
        }

        testDeleteCookie() {
            blib.Cookie.remove( "isLogedIn" );
        }
    }
    /**
     * visualizes and allows ui invocation of the modal
     */
    export var DebugVisualizer = ReactRedux.connect(
        ( reduxStoreState ) => _.clone( reduxStoreState.authentication ) //subscripbe to reduxStore updates (Called every change). 
        , reduxScafolding.action as any //bind actions to props
    )( _DebugVisualizer ) as typeof commonComponents._GenericJsxComponent;




    var Modal = ReactBootstrap.Modal;



    class _Login extends React.Component<
        reduxScafolding.Action & { pushPath: typeof ReduxSimpleRouter.pushPath },
        { email?: string; password?: string; }
    >
    {
        constructor( props: any ) {
            super( props );
            this.state = { email: null, password: null };
        }

        componentWillMount() {
            //send page hit
            blib.ga_ezSpaPageHit();
        }
        public render() {



            return (
                <div>
                    <commonComponents.EzModal ref="Modal" />


                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-block">
                                <div className="card-title"><h4>Login</h4></div>
                                <form onSubmit={ this.handleSubmit.bind( this ) } >
                                    <fieldset className="form-group">
                                        <label htmlFor="emailInput">Email address</label>
                                        <input type="email" className="form-control" id="emailInput" placeholder="Enter email" value={ this.state.email } onChange={ ( e: React.FormEvent ) => { this.setState( { email: e.target.value } ) } } />
                                    </fieldset>
                                    <fieldset className="form-group">
                                        <label htmlFor="passwordInput">Password</label>
                                        <input type="password" className="form-control" id="passwordInput" placeholder="Password" value={ this.state.password } onChange={ ( e: React.FormEvent ) => { this.setState( { password: e.target.value } ) } } />
                                    </fieldset>
                                    <button type="submit" className="btn btn-primary">Login</button>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12">Need to <ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.resetPasswordStart }><strong>Reset</strong></ReactRouter.Link> your password?</div>
                    <div className="col-sm-12">Dont have an account?&nbsp; <ReactRouter.Link to={ config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.signup }><strong>Sign Up</strong></ReactRouter.Link></div>

                </div>
            );
        }


        private openErrorModal( ...errorDetails: any[] ) {
            const content = errorPopupContent( "Error logging in", ...errorDetails );
            // the 2016 account-system transition note stays (port rule)
            const message = (
                <span>
                    <p>{ content.message }</p>
                    <p>On March 21st, 2016 we transitioned to a new account system. If you had a Beta account before then, you will need to re-sign-up.
                        <a href="./20160321-announcement.html" target="_blank" rel="nofollow"><strong>Click here for more details</strong></a>.
                    </p>
                </span>
            );
            var modal = this.refs[ "Modal" ] as commonComponents.EzModal;
            if ( modal != null ) { modal.ShowError( { ...content, message } ); }
        }


        private handleSubmit( e: React.FormEvent ) {
            //log.trace("Login.handleSubmit", e);
            e.preventDefault(); //prevent browser default action of submitting
            var submitCredentials: ioDatatypes.authentication.Payload_LoginSubmitCredentials = {
                email: this.state.email,
                hashedPw: xlib.security.sha512( this.state.password ),
            };

            var origin = window.location.origin;
            var target = origin + config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_login_email;

            //log.assert(false, { origin, route: config.pjscGlobalConfig.sharedConfig.routes.apiRoutePaths.auth_login_email, target, location: window.location });
            return new Promise<void>( ( resolve, reject ) => {
                xlib.net.axios.post( target, submitCredentials )
                    .then( ( response ) => {
                        //var responsePayload = response.data;
                        //log.info("Login.handleSubmit.responsePayload", response);
                        this.props.LoginNotify();
                        this.props.pushPath( config.pjscGlobalConfig.sharedConfig.routes.spaRoutePaths.accountDetails );
                        return resolve();
                    } )
                    .catch( ( err ) => {
                        this.openErrorModal( "response from server:", err.response == null ? "NONE" : err.response.data );
                        return resolve();
                    } );
            } );
        }
    }
    export var Login = ReactRedux.connect(
        null //(reduxStoreState) => _.clone(reduxStoreState.modalPopup) //subscripbe to reduxStore updates (Called every change). 
        , _.merge( {}, reduxScafolding.action, { pushPath: ReduxSimpleRouter.pushPath } ) as any  //redux-binds, then includes the pushPath() method for use in our _App Component
    )( _Login ) as typeof commonComponents._GenericJsxComponent;
}

